/**
 * Tailwind CSS implementation of Duration component
 * Uses the Seeds duration CSS class from duration.css
 */

import React from "react";
import Text from "@sproutsocial/seeds-react-text";
import type { TypeTextProps } from "@sproutsocial/seeds-react-text";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const DurationTailwind = React.forwardRef<
  HTMLSpanElement,
  TypeTextProps
>(({ className, children, ...rest }, ref) => (
  <Text className={cn("seeds-duration", className)} {...rest} ref={ref}>
    {children}
  </Text>
));

DurationTailwind.displayName = "DurationTailwind";
